
import LoadingIcon from '../common/LoadingIcon'
export default {
    name: 'SettingActions',
    components: { LoadingIcon },
    props: {
        state: {
            type: String,
            required: true
        }
    },
    computed: {
        cancelBtnText () {
            if (this.state === 'show') {
                return this.$t('edit')
            }
            return this.$t('cancel')
        }
    },
    methods: {
        emitEvent () {
            if (this.state === 'show') {
                this.edit()
            } else {
                this.reset()
            }
        },
        edit () {
            this.$emit('edit')
        },
        reset () {
            this.$emit('reset')
        },
        submit () {
            if (this.state !== 'submit') {
                this.$emit('submit')
            }
        }
    }
}
